var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.944 19H5.056A1.056 1.056 0 0 1 4 17.944v-7.388C4 9.973 4.473 9.5 5.056 9.5h1.888C7.527 9.5 8 9.973 8 10.556v7.388C8 18.527 7.527 19 6.944 19",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8 10.572 3.649-4.751a1.734 1.734 0 0 1 2.714-.046v0c.265.32.409.725.409 1.14v3.272h3.096a1.8 1.8 0 0 1 1.496.799l.329.49a1.8 1.8 0 0 1 .234 1.5l-1.359 4.722A1.8 1.8 0 0 1 16.839 19H10.55a1.8 1.8 0 0 1-1.318-.574L8 17.1"
  })));
};
export { SvgLike as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYzA3YTJkZjk1NDM1MGIxZGE5N2Q2ZjlkNGViMmM4N2Muc3ZnIjs=";